import { useCallback, useRef } from "react"

import { useDataLayer } from "@/features/DataLayer"
import { useDateParam, useResortParam } from "@/hooks/useSkipassFlow"
import { formatDateForUrl } from "@/utils/dateUtils"

const toKey = (d: Date | null) => (d ? formatDateForUrl(d) : "")

export const usePassSearchEditEvent = () => {
  const { resortExternalId } = useResortParam()
  const { startDate } = useDateParam()
  const pushEdit = useDataLayer("search_pass_edit", { sendOnce: false })

  // latest search criteria
  const lastSubmittedRef = useRef({
    resortExternalId,
    startDateKey: toKey(startDate),
  })

  const trackOnSearchClick = useCallback(
    (resortExternalId: number, startDate: Date | null) => {
      const newSearch = {
        resortExternalId,
        startDateKey: toKey(startDate),
      }

      const last = lastSubmittedRef.current
      const resortChanged = newSearch.resortExternalId !== last.resortExternalId
      const dateChanged = newSearch.startDateKey !== last.startDateKey

      if (resortChanged || dateChanged) {
        pushEdit()
      }

      // update the latest search after button is pressed
      lastSubmittedRef.current = newSearch
    },
    [pushEdit]
  )

  return trackOnSearchClick
}
